<template>
    <div v-if="hasValidContent" ref="mapContainer" class="full">
        <h3 class="block-title text-center" v-if="content.meta.title"><span class="block-title-content  theme-tinted-border">{{this.content.meta.title}}</span></h3>
        <iframe
            width="100%"
            height="500"
            frameborder="0" style="border:0"
            :src="'https://www.google.com/maps/embed/v1/place?key=AIzaSyBkpuL88K4NKBGYsERvQDW1JFmGJ6txLVM&q=' + this.content.address" allowfullscreen>
        </iframe>
    </div>
</template>

<script>
    export default {
        props: ['block', 'providerId', 'context'],

        data() {
            return {
                content: JSON.parse(this.block.content),
                informationBlock: this.block.information_block
            };
        },

        mounted() {
            // This is for re-computation of `staticMapUrl` since the container width is known upon mounted
            this.$nextTick(() => {
                this.$forceUpdate();
            });
        },

        computed: {
            hasValidContent: function() {
                return !!this.content.address && !!this.content.latitude && !!this.content.longitude;
            },
            title: function() {
                return this.content.meta.title || this.informationBlock.title;
            }
        },

        methods: {
            staticMapUrl() {
                if (this.$refs.mapContainer == null) {
                    return null;
                }

                let width = this.$refs.mapContainer.clientWidth;
                let height = 250;
                return "https://maps.googleapis.com/maps/api/staticmap?scale=2&size=" + width + "x" + height + "&markers=color:red%7C" + this.content.latitude + "," + this.content.longitude + "&center=" + this.content.latitude + "," + this.content.longitude + "&key=" + this.context.googleMapApiKey;
            }
        }
    }
</script>

<style scoped></style>
